<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
  <div>
    <div class="my-3 d-flex justify-content-between">
      <div class="font20">Manage Categories</div>
      <div>
        <button class="btn btn-secondary btn-sm" (click)="manage()" id="manage">
          Manage
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-sm-12 col-md-6">
        <div class="category-card">
          <div class="card-header font18 d-flex justify-content-between">
            <div>Categories</div>
            <div [hidden]="IsHidden">
              <button
                class="btn btn-outline-secondary btn-sm"
                modal-trigger="category"
              >
                Add
              </button>
            </div>
          </div>
          <div class="card-body ">
            <div
              [ngClass]="{ isActive: catId == category.id }"
              class="each-category d-flex justify-content-between ho"
              *ngFor="let category of categories"
            >
              <div
                class="flex-grow-1 "
                (click)="getAllSubCategories(category.id, category.name)"
              >
                <span>{{ category.name }}</span>
              </div>
              <img
                class="icon-img"
                src="assets/images/close.png"
                alt=""
                (click)="deleteCategory(category.id)"
                [hidden]="IsHidden"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-12 col-md-6 sm-mt">
        <div class="category-card">
          <div class="card-header font18 d-flex justify-content-between ">
            <div>Subcategories</div>
            <div [hidden]="IsHidden">
              <button
                class="btn btn-outline-secondary btn-sm"
                modal-trigger="sub"
              >
                Add
              </button>
            </div>
          </div>
          <div class="card-body">
            <div
              [ngClass]="{ isActive: subcatId == subCategory.id }"
              class="each-category d-flex justify-content-between ho"
              *ngFor="let subCategory of subCategories"
            >
              <div
                class="flex-grow-1"
                (click)="getAllTopics(subCategory.id, subCategory.name)"
              >
                <span>{{ subCategory.name }}</span>
              </div>
              <img
                class="icon-img"
                src="assets/images/close.png"
                alt=""
                (click)="deleteCategory(subCategory.id)"
                [hidden]="IsHidden"
              />
            </div>
            <div class="each-category " *ngIf="subCategories.length === 0">
              No subcategories yet
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-12 col-md-6 sm-mt">
        <div class="category-card ">
          <div class="card-header font18 d-flex justify-content-between">
            <div>Topics</div>
            <div [hidden]="IsHidden">
              <button
                class="btn btn-outline-secondary btn-sm"
                modal-trigger="topic"
              >
                Add
              </button>
            </div>
          </div>
          <div class="card-body ">
            <div
              class="each-category d-flex justify-content-between ho"
              *ngFor="let topic of topics"
            >
              <span>{{ topic?.name }}</span>
              <img
                class="icon-img"
                src="assets/images/close.png"
                alt=""
                (click)="deleteTopic(topic.id)"
                [hidden]="IsHidden"
              />
            </div>
            <div class="each-category " *ngIf="topics.length === 0">
              No topics yet
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-auto">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>
<app-modal
  elementId="sub"
  headerTitle="Add Subcategory"
  centered="true"
  [styles]="{
    modalBodyHeight: '220px',
    modalContentWidth: '421px'
  }"
>
  <div class="content">
    <hr class="hline" />
    <form action="" class="" [formGroup]="subCategoryForm">
      <div class="form-row">
        <div
          *ngIf="catName"
          class="d-flex justify-content-center mt-5 mb-3 form-group"
        >
          <input type="text" class="asd" value="{{ catName }}" disabled />
          <span class="text-danger">*</span>
        </div>
        <div
          *ngIf="!catName"
          class="d-flex justify-content-center mt-5 mb-3 form-group"
        >
          <input
            type="text"
            class="asd"
            value="Please select a category first"
            disabled
          />
          <span class="text-danger">*</span>
        </div>
      </div>
      <div class="form-row">
        <div class="d-flex justify-content-center mb-4 form-group">
          <input
            type="text"
            class="text-start form-control "
            placeholder="Enter Subcategory Name"
            formControlName="name"
            [ngClass]="{
              'is-invalid':
                subCategoryForm.get('name').errors &&
                subCategoryForm.get('name').touched
            }"
          />
          <span class="text-danger">*</span>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-3">
        <button
          data-dismiss="modal"
          (click)="addSubCategory()"
          class="modalBtn btn-primary"
          type="button"
          [disabled]="subCategoryForm.invalid"
        >
          Add
        </button>
      </div>
    </form>
  </div>
</app-modal>
<app-modal
  elementId="category"
  headerTitle="Add Category"
  centered="true"
  [styles]="{
    modalBodyHeight: '160px',
    modalContentWidth: '421px'
  }"
>
  <div class="content">
    <hr class="hline" />
    <form action="" class="" [formGroup]="categoryForm">
      <div class="form-row mt-5">
        <div class="d-flex justify-content-center mb-4 form-group">
          <input
            type="text"
            class="text-start form-control "
            placeholder="Enter Category Name"
            formControlName="name"
            [ngClass]="{
              'is-invalid':
                categoryForm.get('name').errors &&
                categoryForm.get('name').touched
            }"
          />

          <span class="text-danger">*</span>
        </div>
        <div class="invalid-feedback m-0 p-0">
          Enter category name
        </div>
      </div>

      <div class="d-flex justify-content-center mt-3">
        <button
          data-dismiss="modal"
          (click)="addCategory()"
          class="modalBtn btn-primary"
          type="button"
          [disabled]="categoryForm.invalid"
        >
          Add
        </button>
      </div>
    </form>
  </div>
</app-modal>
<app-modal
  elementId="topic"
  headerTitle="Add Topic"
  centered="true"
  [styles]="{
    modalBodyHeight: '220px',
    modalContentWidth: '421px'
  }"
>
  <div class="content">
    <hr class="hline" />
    <form action="" class="" [formGroup]="topicForm">
      <div class="form-row">
        <div
          *ngIf="subcatName"
          class="d-flex justify-content-center mt-5 mb-3 form-group"
        >
          <input type="text" class="asd" value="{{ subcatName }}" disabled />
          <span class="text-danger">*</span>
        </div>
        <div
          *ngIf="!subcatName"
          class="d-flex justify-content-center mt-5 mb-3 form-group"
        >
          <input
            type="text"
            class="asd"
            value="Please select a subcategory first"
            disabled
          />
          <span class="text-danger">*</span>
        </div>
      </div>
      <div class="form-row">
        <div class="d-flex justify-content-center mb-4 form-group">
          <input
            type="text"
            class="text-start form-control "
            placeholder="Enter Topic Name"
            formControlName="name"
            [ngClass]="{
              'is-invalid':
                topicForm.get('name').errors && topicForm.get('name').touched
            }"
          />
          <span class="text-danger">*</span>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-3">
        <button
          data-dismiss="modal"
          (click)="addTopic()"
          class="modalBtn btn-primary"
          type="button"
          [disabled]="topicForm.invalid"
        >
          Add
        </button>
      </div>
    </form>
  </div>
</app-modal>
